/* OVRS — quick add
   ------------------------------------------------------------------
   Abre a janela do produto a partir do card: foto, preco, tamanho,
   Add to bag e Buy now. Os dados vem de /products/<handle>.js no clique,
   entao a home nao carrega o catalogo inteiro em atributos HTML e o preco
   nunca fica velho. O Section Store Cart e o carrinho principal; o drawer
   nativo do tema fica como fallback se o app nao estiver disponivel. */
(function () {
  var root = document.getElementById('ovrsQuickAdd');
  if (!root) return;

  var txt = window.ovrsQaStrings || {};
  var painel = root.querySelector('.ovrs-qa__panel');
  var elMedia = root.querySelector('[data-qa-media]');
  var elTitle = root.querySelector('[data-qa-title]');
  var elPrice = root.querySelector('[data-qa-price]');
  var elWas = root.querySelector('[data-qa-was]');
  var elDesc = root.querySelector('[data-qa-desc]');
  var elSizes = root.querySelector('[data-qa-sizes]');
  var elMsg = root.querySelector('[data-qa-msg]');
  var btnAdd = root.querySelector('[data-qa-add]');
  var btnBuy = root.querySelector('[data-qa-buy]');
  var elFull = root.querySelector('[data-qa-full]');

  var escolhido = null;
  var cache = {};
  var ultimoFoco = null;
  var pedidoAtual = 0;
  var raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  function dinheiro(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  function avisar(t, erro) {
    elMsg.textContent = t || '';
    elMsg.classList.toggle('is-err', !!erro);
  }

  function abrir() {
    ultimoFoco = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ovrs-qa-lock');
    painel.setAttribute('tabindex', '-1');
    painel.focus();
  }

  function fechar() {
    root.hidden = true;
    document.documentElement.classList.remove('ovrs-qa-lock');
    avisar('');
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  function pintar(p) {
    escolhido = null;
    avisar('');

    elTitle.textContent = p.title;
    elFull.href = raiz + '/products/' + p.handle;
    elPrice.textContent = dinheiro(p.price);
    elWas.textContent = p.compare_at_price && p.compare_at_price > p.price ? dinheiro(p.compare_at_price) : '';

    // descricao vem em HTML; aqui so o texto, cortado — o resto esta na PDP
    var tmp = document.createElement('div');
    tmp.innerHTML = p.description || '';
    var texto = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    elDesc.textContent = texto.length > 190 ? texto.slice(0, 190).trim() + '...' : texto;

    elMedia.innerHTML = '';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = p.featured_image;
      img.alt = p.title;
      elMedia.appendChild(img);
    }

    elSizes.innerHTML = '';
    p.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ovrs-qa__size';
      // titulo vem "Cor / Tamanho"; a cor ja foi decidida no card
      b.textContent = v.title.indexOf('/') > -1 ? v.title.split('/').pop().trim() : v.title;
      b.setAttribute('aria-pressed', 'false');
      if (!v.available) {
        b.disabled = true;
        b.classList.add('ovrs-qa__size--out');
      }
      b.addEventListener('click', function () {
        escolhido = v.id;
        elSizes.querySelectorAll('.ovrs-qa__size').forEach(function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        avisar('');
      });
      elSizes.appendChild(b);
    });

    // uma variante disponivel so: nao ha decisao a tomar
    var disp = p.variants.filter(function (v) { return v.available; });
    if (disp.length === 1) {
      escolhido = disp[0].id;
      var unico = elSizes.querySelector('.ovrs-qa__size:not([disabled])');
      if (unico) unico.setAttribute('aria-pressed', 'true');
    }
    if (!disp.length) avisar(txt.soldOut || 'Sold out', true);
  }

  function carregar(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(raiz + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found');
        return r.json();
      })
      .then(function (p) {
        cache[handle] = p;
        return p;
      });
  }

  function exigirTamanho() {
    if (escolhido) return true;
    avisar(txt.chooseSize || 'Choose a size first.', true);
    var primeiro = elSizes.querySelector('.ovrs-qa__size:not([disabled])');
    if (primeiro) primeiro.focus();
    return false;
  }

  function adicionar(depois) {
    if (!exigirTamanho()) return;
    btnAdd.disabled = true;
    btnBuy.disabled = true;

    fetch(raiz + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: escolhido, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function () { depois(); })
      .catch(function (err) {
        console.error('[ovrs-quick-add]', err);
        avisar(err.message, true);
      })
      .finally(function () {
        btnAdd.disabled = false;
        btnBuy.disabled = false;
      });
  }

  function abrirCarrinhoNativo() {
    document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
    var trigger = document.querySelector('a[aria-controls="CartDrawer"]');
    if (!trigger) { window.location.href = raiz + '/cart'; return; }
    var done = false, timer;
    var onRender = function () {
      if (done) return;
      done = true;
      clearTimeout(timer);
      document.removeEventListener('cart:drawer:render', onRender);
      trigger.click();
    };
    timer = setTimeout(function () {
      if (done) return;
      done = true;
      document.removeEventListener('cart:drawer:render', onRender);
      window.location.href = raiz + '/cart';
    }, 2500);
    document.addEventListener('cart:drawer:render', onRender);
  }

  function irParaCarrinho() {
    window.location.href = raiz + '/cart';
  }

  function abrirCarrinho() {
    var app = window.SectionStoreCart;
    if (app && typeof app.open === 'function') {
      try {
        var abertura = app.open();
        if (abertura && typeof abertura.catch === 'function') abertura.catch(irParaCarrinho);
        return;
      } catch (err) { irParaCarrinho(); return; }
    }
    abrirCarrinhoNativo();
  }

  btnAdd.addEventListener('click', function () {
    adicionar(function () {
      fechar();
      abrirCarrinho();
    });
  });

  btnBuy.addEventListener('click', function () {
    adicionar(function () { window.location.href = raiz + '/checkout'; });
  });

  root.querySelectorAll('[data-qa-close]').forEach(function (b) {
    b.addEventListener('click', fechar);
  });

  root.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); fechar(); return; }
    if (e.key !== 'Tab') return;
    var focaveis = Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]),select:not([disabled]),input:not([disabled]),[href],[tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return !el.hidden && el.getClientRects().length; });
    if (!focaveis.length) return;
    var primeiro = focaveis[0], ultimo = focaveis[focaveis.length - 1];
    if (document.activeElement === painel) { e.preventDefault(); (e.shiftKey ? ultimo : primeiro).focus(); }
    else if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
  });

  // delegado: cobre cards que chegam depois (troca de aba, section reload)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ovrs-quick]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var pedido = ++pedidoAtual;

    btn.classList.add('is-loading');
    carregar(handle)
      .then(function (p) {
        if (pedido !== pedidoAtual) return;
        pintar(p); abrir();
      })
      .catch(function (err) {
        if (pedido !== pedidoAtual) return;
        console.error('[ovrs-quick-add]', err);
        // sem dados nao ha o que decidir na janela: manda para a PDP
        window.location.href = raiz + '/products/' + handle;
      })
      .finally(function () { btn.classList.remove('is-loading'); });
  });
})();
